import baseRoute from '../baseRoute';

export type * from './requestModel';

type RouteDefinition = `${typeof baseRoute}/${number | ':workOrderId'}/publish`;

export const ROUTE: RouteDefinition = `${baseRoute}/:workOrderId/publish`;

export const URL = (workOrderId: number): RouteDefinition => `${baseRoute}/${workOrderId}/publish`;
